import http from 'plugins/axios';

function query(params = {}) {
  return Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
}

export default {
  enums() {
    return http.get({ url: '/ta/admin/tenant/vip/whitelist/enums' });
  },
  page(params) {
    return http.get({ url: `/ta/admin/tenant/vip/whitelist/page?${query(params)}` });
  },
  save(data) {
    return http.post({ url: '/ta/admin/tenant/vip/whitelist/save', data });
  },
  delete(id) {
    return http.post({ url: `/ta/admin/tenant/vip/whitelist/delete?id=${encodeURIComponent(id)}` });
  },
};
